const SAY_AS_TYPE = "ssml-say-as";

export { SAY_AS_TYPE };
//# sourceMappingURL=constant.js.map
